module.exports = __webpack_public_path__ + "static/media/softSkillsIcon.0da766aa.png";